import {
  CartographyAosPictureApi,
  CartographyBasiasBasolSisNearbySiteOtherApi,
  CartographyBuildingApi,
  CartographyComponentApi,
  CartographyOtherItemApi,
  CartographyOutdoorSpaceApi,
  CartographyPolygonApi,
  CartographySiteApi,
  CartographySpreadingApi,
  CartographyZoneApi,
} from "@socotec.io/ssp-back-sdk";
import { sspProjectConfig } from "@/setup/openApiConfig";

export const aosPictureApi = new CartographyAosPictureApi(sspProjectConfig);
export const basiasBasolSisNearbySiteOtherApi = new CartographyBasiasBasolSisNearbySiteOtherApi(
  sspProjectConfig,
);
export const buildingApi = new CartographyBuildingApi(sspProjectConfig);
export const componentApi = new CartographyComponentApi(sspProjectConfig);
export const otherItemApi = new CartographyOtherItemApi(sspProjectConfig);
export const outdoorSpaceApi = new CartographyOutdoorSpaceApi(sspProjectConfig);
export const polygonApi = new CartographyPolygonApi(sspProjectConfig);
export const siteApi = new CartographySiteApi(sspProjectConfig);
export const spreadingApi = new CartographySpreadingApi(sspProjectConfig);
export const zoneApi = new CartographyZoneApi(sspProjectConfig);
